import { createTheme } from '@mui/material';
import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
});

export const StyledOption = styled('option')({
  fontSize:'18px',
});
